export default "__VITE_ASSET__wT9WkMf6__"